import {
  COUNT_GENUS_FAILED,
  COUNT_GENUS_SUCCEED,
  COUNT_GENUS_PROCESSING,
  FETCH_GENUS_FAILED,
  FETCH_GENUS_SUCCEED,
  FETCH_GENUS_PROCESSING,
  GET_GENUS_FAILED,
  GET_GENUS_SUCCEED,
  GET_GENUS_PROCESSING,
  FETCH_GENUS_CATEGORIES_FAILED,
  FETCH_GENUS_CATEGORIES_SUCCEED,
  FETCH_GENUS_CATEGORIES_PROCESSING,
  FETCH_GENUS_PRODUCTS_FAILED,
  FETCH_GENUS_PRODUCTS_SUCCEED,
  FETCH_GENUS_PRODUCTS_PROCESSING,
  SAVE_GENUS_FAILED,
  SAVE_GENUS_SUCCEED,
  SAVE_GENUS_PROCESSING,
  DELETE_GENUS_FAILED,
  DELETE_GENUS_SUCCEED,
  DELETE_GENUS_PROCESSING,
  HIDE_ALERT,
} from '../constants'

const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  deleting: false,
  deleted: false,
  errorMessage: '',
  list: [],
  total: 0,
  categories: [],
  products: [],
  record: {
    genusName: '',
    categoryType: {},
    commonName: '',
    genusProduct: [],
  },
}

const genus = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GENUS_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errorMessage: action.payload.error,
        list: [],
      }
    case FETCH_GENUS_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        errorMessage: '',
      }
    case FETCH_GENUS_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: action.payload.list,
        errorMessage: '',
      }
    case GET_GENUS_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        errorMessage: action.payload.error,
        record: initialState.record,
      }
    case GET_GENUS_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        errorMessage: '',
      }
    case GET_GENUS_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        record: action.payload.record,
        errorMessage: '',
      }
    case FETCH_GENUS_CATEGORIES_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        errorMessage: action.payload.error,
      }
    case FETCH_GENUS_CATEGORIES_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case FETCH_GENUS_CATEGORIES_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        categories: action.payload.categories,
      }
    case COUNT_GENUS_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errorMessage: action.payload.error,
      }
    case COUNT_GENUS_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case COUNT_GENUS_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        total: action.payload.total,
      }
    case FETCH_GENUS_PRODUCTS_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        errorMessage: action.payload.error,
      }
    case FETCH_GENUS_PRODUCTS_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case FETCH_GENUS_PRODUCTS_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        products: action.payload.products,
      }
    case SAVE_GENUS_FAILED:
      return {
        ...state,
        saving: false,
        saved: true,
        errorMessage: action.payload.error,
      }
    case SAVE_GENUS_PROCESSING:
      return {
        ...state,
        saving: true,
        saved: false,
      }
    case SAVE_GENUS_SUCCEED:
      return {
        ...state,
        saving: false,
        saved: true,
      }
    case DELETE_GENUS_FAILED:
      return {
        ...state,
        deleting: false,
        deleted: false,
        errorMessage: action.payload.error,
      }
    case DELETE_GENUS_PROCESSING:
      return {
        ...state,
        deleting: true,
        deleted: false,
      }
    case DELETE_GENUS_SUCCEED:
      return {
        ...state,
        deleting: false,
        deleted: true,
      }
    case HIDE_ALERT:
      return {
        ...state,
        fetched: false,
        saved: false,
        errorMessage: '',
        deleted: false,
      }
    default:
      return state
  }
}

export default genus
